import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

import Slider from '@mui/material/Slider';
import CircularProgress from '@mui/material/CircularProgress';
import { COLORS } from '../../utils/colors';

import SelectModel from './SelectModel';

import { useCopilotContext } from '../../contexts/CopilotContext';
import { useCopilotStyles } from './styles';

const CopilotFilter = () => {
  const styles = useCopilotStyles();

  const {
    filterTranscriptContext,
    setFilterTranscriptContext,

    scoreThreshold,
    setScoreThreshold,

    storeTranscriptEmbeddingsLoading,
    storeTranscriptEmbeddingsError,

    setFilterTranscriptResultsMap,

    filterTranscriptPrompt,
    setFilterTranscriptPrompt,
    filterTranscriptLoading,
    filterTranscriptError,

    filterModel,

    filterTranscriptWithDecoder,
    isFilteringTranscript,
    filterTranscriptResultsMap,

    setErrorFilteringTranscript,
    errorFilteringTranscript,

    storeFilterResults,
    filterTranscriptResultsStore,
  } = useCopilotContext();

  useEffect(() => {
    if (!filterTranscriptPrompt) setPromptInput('');
  }, [filterTranscriptPrompt]);

  const [promptInput, setPromptInput] = useState<string>(
    filterTranscriptPrompt,
  );
  const [contextInput, setContextInput] = useState<string>(
    filterTranscriptContext,
  );
  const [enableApply, setEnableApply] = useState<boolean>(false);
  const [requestSaveFilterResults, setRequestSaveFilterResults] =
    useState<boolean>(false);

  useEffect(() => {
    setEnableApply(true);
  }, [filterModel]);

  const applyFilter = () => {
    console.log(
      `CopilotFilter applyFilter: '${promptInput}' with model: ${filterModel}`,
    );

    setFilterTranscriptPrompt(promptInput);
    setFilterTranscriptContext(contextInput);

    setEnableApply(false);
    //setErrorFilteringTranscript(false);
    setRequestSaveFilterResults(false);

    if (filterModel > 0) {
      filterTranscriptWithDecoder();
      setRequestSaveFilterResults(true);
    }
  };

  useEffect(() => {
    setEnableApply(promptInput !== filterTranscriptPrompt);
  }, [promptInput]);

  const handleSliderChange = (event: any) => {
    setScoreThreshold(event.target.value);
  };

  const handleInputChange = (event: any) => {
    setErrorFilteringTranscript(false);
    //setRequestSaveFilterResults(false);
    setPromptInput((prev) => event.target.value);
    setFilterTranscriptResultsIndex('');
  };

  useEffect(() => {
    setErrorFilteringTranscript(false);
  }, [enableApply]);

  useEffect(() => {
    setRequestSaveFilterResults(false);
  }, [errorFilteringTranscript]);

  const handleContextChange = (event: any) => {
    setRequestSaveFilterResults(false);
    setContextInput((prev) => event.target.value);
    setFilterTranscriptResultsIndex('');
  };

  const [filterTranscriptResultsIndex, setFilterTranscriptResultsIndex] =
    useState<string>('');
  const handleFilterTranscriptResultsIndexChange = (event: any) => {
    setFilterTranscriptResultsIndex(event.target.value);

    const filterResult = filterTranscriptResultsStore[event.target.value];

    setPromptInput(filterResult.prompt);
    setContextInput(filterResult.context);

    console.log(
      'handleFilterTranscriptResultsIndexChange setFilterTranscriptResultsMap...',
    );
    setFilterTranscriptResultsMap(
      new Map<string, number>(Object.entries(filterResult.results)),
    );
    setRequestSaveFilterResults(false);
  };

  const handleStoreFilterResults = () => {
    const count = filterTranscriptResultsStore.length;

    storeFilterResults();
    setFilterTranscriptResultsIndex(String(count));
    setRequestSaveFilterResults(false);
  };

  console.log(
    '::::repaint Copilot filter filterTranscriptResultsMap.size: ' +
      filterTranscriptResultsMap.size,
  );

  return (
    <>
      <Box style={{ marginTop: '1rem', minHeight: '3rem' }}>
        {
          <SelectModel
            onChange={() => {
              setRequestSaveFilterResults(false);
            }}
          />
        }
        {filterModel === 0 && filterTranscriptResultsMap.size > 0 && (
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography
              sx={{ width: '12rem', lineHeight: '4rem', padding: '0' }}
              id="slider-label"
              gutterBottom>
              Score Threshhold ({scoreThreshold})
            </Typography>
            <Slider
              sx={{ margin: '1rem 0', width: 150 }}
              value={scoreThreshold}
              onChange={handleSliderChange}
              min={0}
              max={1}
              step={0.01}
              aria-labelledby="slider-label"
            />
          </Box>
        )}
        {filterModel > 0 && filterTranscriptResultsStore.length > 0 && (
          <FormControl component="fieldset" sx={styles.storedFilters}>
            <FormControl
              sx={{ minWidth: '15rem', marginRight: '.5rem', width: '100%' }}>
              <InputLabel
                id="select-label"
                shrink
                sx={{ backgroundColor: '#eee', margin: '0 1rem' }}>
                Stored Filters
              </InputLabel>
              <Select
                labelId="select-label"
                sx={styles.selectStoredFilter}
                value={filterTranscriptResultsIndex}
                onChange={handleFilterTranscriptResultsIndexChange}>
                {filterTranscriptResultsStore.map((model, index) => (
                  <MenuItem key={index} value={index}>
                    {`${model.model}: ${model.prompt}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </FormControl>
        )}
      </Box>

      {storeTranscriptEmbeddingsLoading && (
        <CircularProgress size={20} sx={{ color: COLORS.PRIMARY }} />
      )}

      {storeTranscriptEmbeddingsError && (
        <Typography style={{ color: 'red', fontWeight: 'bold' }}>
          Error !
        </Typography>
      )}

      {!storeTranscriptEmbeddingsError && !storeTranscriptEmbeddingsLoading && (
        <>
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
            }}>
            <TextField
              sx={styles.promptInput}
              label="Filter prompt"
              disabled={filterTranscriptLoading}
              value={promptInput}
              onChange={handleInputChange}
            />
            {!isFilteringTranscript &&
            !errorFilteringTranscript &&
            requestSaveFilterResults ? (
              <Button sx={styles.buttonSave} onClick={handleStoreFilterResults}>
                Save
              </Button>
            ) : (
              <Button
                sx={styles.buttonApply}
                onClick={applyFilter}
                disabled={!enableApply || !promptInput}>
                {errorFilteringTranscript ? (
                  'Error !'
                ) : isFilteringTranscript ? (
                  <>
                    {isFilteringTranscript &&
                      filterModel > 0 &&
                      `${isFilteringTranscript}%`}
                    <CircularProgress
                      size={20}
                      sx={{ color: COLORS.PRIMARY }}
                    />
                  </>
                ) : (
                  'Apply'
                )}
              </Button>
            )}
          </Box>
          {filterModel > 0 && (
            <Box>
              <TextField
                sx={styles.contextInput}
                label="Filter Context"
                disabled={filterTranscriptLoading}
                value={contextInput}
                onChange={handleContextChange}
                multiline
                rows={3}
              />
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default CopilotFilter;
